import React from 'react';

const Loader = () => {
    return (
        <div className="loader-container">
            <div className="spinner" />
            <span className="loader-text">Loading</span>
        </div>
    );
};

export default Loader;
